import { ActionType, getType } from "typesafe-actions";
import * as actions from "../actions/subscriptionAction";
import { ICreateSubscriptionResponse, ISubscriptionPlansResponse, IUserSubscription } from "src/models/Subscription";

export interface ISubscriptionState {
  plans: {
    isFetching: boolean;
    error?: Error;
    data: ISubscriptionPlansResponse;
  };
  userSubs: {
    isFetching: boolean;
    error?: Error;
    data: IUserSubscription[];
  };
  createSubscription: {
    isFetching: boolean;
    error?: Error;
    data?: ICreateSubscriptionResponse;
  };
}

const initialState: ISubscriptionState = {
  plans: { isFetching: false, data: { monthly: [], annual: [] } },
  userSubs: { isFetching: false, data: [] },
  createSubscription: { isFetching: false }
};

type Action = ActionType<typeof actions>;

export const subscriptionReducer = (
  state: ISubscriptionState = initialState,
  action: Action
): ISubscriptionState => {
  switch (action.type) {
    /* ------- plans ------- */
    case getType(actions.fetchPlans.request):
      return { ...state, plans: { ...state.plans, isFetching: true, error: undefined } };
    case getType(actions.fetchPlans.success):
      return { ...state, plans: { isFetching: false, data: action.payload } };
    case getType(actions.fetchPlans.failure):
      return { ...state, plans: { ...state.plans, isFetching: false, error: action.payload } };

    /* ------- user subscriptions ------- */
    case getType(actions.fetchUserSubscriptions.request):
      return { ...state, userSubs: { ...state.userSubs, isFetching: true, error: undefined } };
    case getType(actions.fetchUserSubscriptions.success):
      return { ...state, userSubs: { isFetching: false, data: action.payload } };
    case getType(actions.fetchUserSubscriptions.failure):
      return { ...state, userSubs: { ...state.userSubs, isFetching: false, error: action.payload } };

    case getType(actions.createSubscription.request):
      return { 
        ...state, 
        createSubscription: { ...state.createSubscription, isFetching: true, error: undefined } 
      };
    case getType(actions.createSubscription.success):
      return {
        ...state,
        createSubscription: { isFetching: false, data: action.payload }
      };
    case getType(actions.createSubscription.failure):
      return { 
        ...state, 
        createSubscription: { ...state.createSubscription, isFetching: false, error: action.payload } 
      };

    /* ------- delete subscription ------- */
    case getType(actions.deleteSubscription.request):
      return { ...state }; // Could add loading state here if needed
    case getType(actions.deleteSubscription.success):
      return {
        ...state,
        userSubs: {
          ...state.userSubs,
          data: state.userSubs.data.filter(s => s.subscriptionId !== action.payload)
        }
      };
    case getType(actions.deleteSubscription.failure):
      return { ...state }; // Could add error state here if needed

    case getType(actions.resetSubscriptions):
      return initialState;

    default:
      return state;
  }
};
